export default "__VITE_ASSET__Cy0uP4aD__"